<homey-page-title title="Login"/>
<div>
  @if (loginResult()) {
    @if (loginResult() && loginResult() !== 'success') {
      @switch (loginResult()) {
        @case ('invalid-email') {
          <homey-error-message>A user with the given email does not exist. Ensure you use the correct capitalization.
          </homey-error-message>
        }
        @case ('google-account') {
          <homey-error-message>You created this account with Google, please use the Google login button.
          </homey-error-message>
        }
        @case ('apple-account') {
          <homey-error-message>You created this account with Apple, please use the Apple login button.
          </homey-error-message>
        }
        @case ('invalid-password') {
          <homey-error-message>Invalid password.</homey-error-message>
        }
      }
    }
  }
  <homey-custom-form [formGroup]="form" submitButtonLabel="Continue" [submitFunction]="submit">
    <homey-form-inputs>
      <homey-text-input [inputFormControl]="form.controls.email"
                        inputId="email"
                        label="Email address"
                        type="email"/>
      <div>
        <homey-text-input class="block mb-2" [inputFormControl]="form.controls.password"
                          inputId="password"
                          label="Password"
                          [showPasswordToggle]="true"
                          [type]="{
                        type: 'password',
                        autocomplete: 'current-password'
                      }"
        />
        <a [routerLink]="['forgot-password']" class="underline">Forgot password?</a>
      </div>
      <homey-terms-conditions-checkbox [formControlInput]="form.controls.conditions"/>
    </homey-form-inputs>
  </homey-custom-form>
</div>
<p-divider align="center" [dt]="whiteDividerDt">
  <p class="text-surface-500">or</p>
</p-divider>
<homey-login-with-google-button
  [agreedToTerms]="form.controls.conditions.getRawValue()" [oathState]="
    {redirectUrl: redirectUrlWithFallback(), initialFormCommand: undefined}
"/>
<homey-login-with-apple-button
  class="mt-2"
  [agreedToTerms]="form.controls.conditions.getRawValue()" [oathState]="
    {redirectUrl: redirectUrlWithFallback(), initialFormCommand: undefined}
"/>

<p class="mt-auto text-sm text-muted-color">Don't have an account?   <a [routerLink]="initialSignupRoute" class="underline">Sign up!</a></p>

